import { Box, Typography } from '@mui/material'

import ToothIcon from '@/assets/images/fi-rs-tooth.png'
import PieChart from '@/components/PieChart'
import { isNullorEmptyArr } from '@/utils'

type OpaquersEntity = {
  internallayer_advice: any
}

const OpaquerRecipe = ({ internallayer_advice }: OpaquersEntity) => {
  const renderPieChartSection = (title: string, labels: any, values: any) => {
    return (
      <Box
        sx={{
          background:
            'linear-gradient(133.84deg, #4e4e4e -16.04%, #333333 9.33%, #1a1a1a 32.02%, #1a1a1a 62.06%, #262626 87.42%, #4e4e4e 112.12%)',
          boxShadow: '2px 6px 15px 2px rgba(12, 10, 11, 0.8)',
          borderRadius: 2,
          height: '100%',
          margin: 'auto',
          width: '31%',
          aspectRatio: '284 / 340',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 2,
        }}
      >
        {/* Title */}
        <Box display="flex" alignItems="center" margin={3} gap={2}>
          <Box
            component="img"
            src={ToothIcon}
            sx={{ height: '24px', width: '24px' }}
          />
          <Typography variant="h5" fontWeight="bold">
            {title}
          </Typography>
        </Box>

        {/* Pie Chart */}
        <PieChart labels={labels} values={values} />
      </Box>
    )
  }

  return (
    <Box display="flex" height="100%" paddingBottom={2}>
      {isNullorEmptyArr(
        [internallayer_advice, 'opaquers_cervical'],
        [internallayer_advice, 'opaquers_ratios_cervical'],
      ) &&
        renderPieChartSection(
          'Cervical',
          internallayer_advice.opaquers_cervical,
          internallayer_advice.opaquers_ratios_cervical,
        )}

      {isNullorEmptyArr(
        [internallayer_advice, 'opaquers_middle'],
        [internallayer_advice, 'opaquers_ratios_middle'],
      ) &&
        renderPieChartSection(
          'Middle',
          internallayer_advice.opaquers_middle,
          internallayer_advice.opaquers_ratios_middle,
        )}

      {isNullorEmptyArr(
        [internallayer_advice, 'opaquers_incisal'],
        [internallayer_advice, 'opaquers_ratios_incisal'],
      ) &&
        renderPieChartSection(
          'Incisal',
          internallayer_advice.opaquers_incisal,
          internallayer_advice.opaquers_ratios_incisal,
        )}
    </Box>
  )
}

export default OpaquerRecipe
